var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('photoshop-picker',{on:{"ok":_vm.handleAccept,"cancel":_vm.handleCancel},model:{value:(_vm.selected_color),callback:function ($$v) {_vm.selected_color=$$v},expression:"selected_color"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }